import { render, staticRenderFns } from "./BranchesIndicator.vue?vue&type=template&id=5f3d703f&"
import script from "./BranchesIndicator.vue?vue&type=script&lang=js&"
export * from "./BranchesIndicator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports